<template>
<!--  <div class="content_main">
    <div class="content_main_top">
      <a-input placeholder="请输入领用单号" class="a_input_self margin_self" />
      <a-input placeholder="请输入产品名称" class="a_input_self margin_self" />
      <a-input placeholder="请输入产品编号" class="a_input_self margin_self" />
      <a-select show-search allowClear placeholder="请选择部门" class="a_input_self margin_self" @change="handleChange">
        <a-select-option value="jack"> Jack </a-select-option>
        <a-select-option value="lucy"> Lucy </a-select-option>
        <a-select-option value="Yiminghe"> yiminghe </a-select-option>
      </a-select>
      <a-input placeholder="请输入领用人" class="a_input_self margin_self" />
      <a-button type="primary" style="margin: 5px"> 查询 </a-button>
      <a-button type="primary" @click="examine" style="margin: 5px"> 审核 </a-button>
    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <a-table
        :columns="columns2"
        :data-source="data3"
        :row-selection="rowSelection"
        :expanded-row-keys.sync="expandedRowKeys"
		:scroll="{  y: scroll_y }"
      />
    </div>

    <a-modal title="审核" v-model="visibleexamine" on-ok="handleOk3" width="880px">
      <template slot="footer">
        <div class="flex">
          <a-button key="submit" type="danger"> 驳回 </a-button>
          <a-input placeholder="请输入驳回原因" />
          <a-button key="submit" type="primary" :loading="loading" @click="handleOk3"> 提交 </a-button>
        </div>
      </template>
      <div class="center">
        <a-table
          :columns="columns3"
          :data-source="data3"
          :row-selection="rowSelection"
          :expanded-row-keys.sync="expandedRowKeys"
        >
          <a-input slot="amo" slot-scope="text" style="width: 100px" />
          <a-input slot="name" slot-scope="text" style="width: 100px" />
        </a-table>
      </div>
    </a-modal>
  </div>
 -->
 <div style="text-align: center;">
 	<div style="color: #909090;font-size: 20px;">功能正在开发中…</div>
 	<img src="../../../public/kaifa.png" />
 </div>
 </template>

<script>
import { get_list, purchase } from '@/api/assetmenag'
const columns2 = [
  {
    title: '领用单号',
    dataIndex: 'amo',
    key: 'amo',
  },
  {
    title: '部门',
    dataIndex: 'amo',
    key: 'amo',
  },
  {
    title: '领用人',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '产品名',
    dataIndex: 'amo',
    key: 'amo',
  },
  {
    title: '产品编号',
    dataIndex: 'amo',
    key: 'amo',
  },
  {
    title: '数量',
    dataIndex: 'amount',
    key: 'amount',
  },
  {
    title: '领用时间',
    dataIndex: 'amo',
    key: 'amo',
  },
]
const columns3 = [
  {
    title: '领用单号',
    dataIndex: 'amo',
    key: 'amo',
  },
  {
    title: '部门',
    key: 'amo',
    scopedSlots: {
      customRender: 'amo',
    },
  },
  {
    title: '领用人',
    key: 'name',
    scopedSlots: {
      customRender: 'name',
    },
  },
  {
    title: '产品名',
    dataIndex: 'amo',
    key: 'amo',
  },
  {
    title: '产品编号',
    dataIndex: 'amo',
    key: 'amo',
  },
  {
    title: '数量',
    dataIndex: 'amount',
    key: 'amount',
  },
  {
    title: '领用时间',
    dataIndex: 'amo',
    key: 'amo',
  },
]
const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
  },
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows)
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    console.log(selected, selectedRows, changeRows)
  },
}

export default {
  data() {
    return {
		scroll_y:150,
      visibleexamine: false,
      columns2,
      columns3,
      expandedRowKeys: [],
      rowSelection,
      loading: false,
    }
  },
  created() {
   
  },
   mounted(){
    this.$nextTick(()=>{
      var max_h=$('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y=max_h-$(".ant-table-header").height();
      }, 1000);
    })
  },
  methods: {
    Exadd() {
      this.visibleClaim = true
    },
    examine() {
      this.visibleexamine = true
    },
    handleOk3(e) {
      this.loading = true
      setTimeout(() => {
        this.visibleexamine = false
        this.loading = false
      }, 2000)
    },
  },
}
</script>

<style>
.dialog {
  display: flex;
  justify-content: space-between;
}
.flex {
  display: flex;
}
.center {
  text-align: center;
  width: 832px;
}

.dialog .dialog_item {
  margin-bottom: 5px;
  width: 220px;
  display: flex;
  justify-content: space-between;
}

.Exhi {
  display: inline-block;
  border: 1px solid black;
  width: 100px;
  text-align: left;
  color: steelblue;
}
</style>
